import { IconButton, Stack } from '@mui/material';
import { TrashIcon } from '@phosphor-icons/react';

import { Text, colors } from 'common';

import { useReactFlowViewContext } from '../../../../context/context';

interface ResponseFormatFieldHeaderProps {
  headerLabel: string;
  onDelete: () => void;
}

export function ResponseFormatFieldHeader(props: ResponseFormatFieldHeaderProps) {
  const { headerLabel, onDelete } = props;
  const { isEditable } = useReactFlowViewContext();

  return (
    <Stack
      direction="row"
      padding={1}
      paddingLeft={2}
      justifyContent="space-between"
      alignItems="center"
      sx={{
        backgroundColor: colors.background.disabled,
        borderRadius: 1,
      }}
    >
      <Text variant="heading5" bold>
        {headerLabel}
      </Text>
      <IconButton
        aria-label="Delete Field"
        size="medium"
        onClick={() => onDelete()}
        disabled={!isEditable}
      >
        <TrashIcon size={16} />
      </IconButton>
    </Stack>
  );
}
